import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'
import { MONTHLY_YEARLY_UPGRADE_PLAN_MAP } from '@/constant/monthlyToYearlyUpgrade'
import Util from '@/util'

const planLimit = (state) => {
  return state.plan.limit
}

const canUseFeaturesByPlanAPI = (_, __, ___, rootGetters) => {
  return isFeatureEnabled(rootGetters, 'release-features-by-plan-api')
}

const eligibleToUpgradeFromMonthlyToYearly = (state) => {
  if (state.currentAccount?.id) return false
  if (!state.monthlyToYearlyUpgradePreview ||
    !state.monthlyToYearlyUpgradePreview.amountToUpgrade ||
    !state.monthlyToYearlyUpgradePreview.amountToUpgrade.amount
  ) return false
  return !!MONTHLY_YEARLY_UPGRADE_PLAN_MAP[state.currentUser.plan]
}

const monthlyToYearlyUpgradeAmount = (state) => {
  if (!state?.monthlyToYearlyUpgradePreview?.amountToUpgrade) return null
  const { amount, currencySymbol } = state.monthlyToYearlyUpgradePreview.amountToUpgrade
  const monthlyAmount = Math.ceil(amount / 12)
  const formattedAmount = Util.formatNumberWithCommas(monthlyAmount)
  return `${currencySymbol}${formattedAmount}`
}

const monthlyToYearlyUpgradePromotionCode = (state) => {
  return state.monthlyToYearlyUpgradePreview?.promotionCode
}

const shouldShowMonthlyToYearlyPromo = (state, getters, rootState, rootGetters) => {
  // Check if user has the feature enabled
  const hasFeatureEnabled = rootGetters['featureToggles/canUserOfferingMonthlyToYearly']

  // Check if user is eligible for upgrade
  const isEligible = getters.eligibleToUpgradeFromMonthlyToYearly

  return hasFeatureEnabled &&
         isEligible
}

export default {
  planLimit,
  canUseFeaturesByPlanAPI,
  eligibleToUpgradeFromMonthlyToYearly,
  monthlyToYearlyUpgradeAmount,
  monthlyToYearlyUpgradePromotionCode,
  shouldShowMonthlyToYearlyPromo,
}
